module.exports = __webpack_public_path__ + "img/round2.75f792e5.png";